import { http } from "./http";

export type About = {
    version: string;
};

export const aboutApi = {
    async about(): Promise<About> {
        const { data } = await http.get<About>("/api/v0/about");
        return data;
    },
};
